import { z } from 'zod';

import { listDirectory } from './list-directory';
import type { GraphGroup, GraphListResult, ListGroupsOptions } from './types';

const groupSchema: z.ZodType<GraphGroup> = z
  .object({
    '@odata.type': z.string().optional(),
    appId: z.string().optional(),
    description: z.string().nullish(),
    displayName: z.string().nullish(),
    id: z.string().optional(),
  })
  .passthrough();

/**
 * Lists one page of Microsoft Graph groups through Backstage's authenticated proxy.
 *
 * @param options - The explicit Graph version, authenticated fetch, query options and transport controls.
 * @returns One validated page. `more`, when present, is a bound zero-argument continuation and can reject with the shared `@ns/http-request` failures.
 */
export function listGroups(
  options: ListGroupsOptions,
): Promise<GraphListResult<GraphGroup>> {
  return listDirectory(options, 'groups', groupSchema);
}
